// src/features/streams/components/StreamLiveStatusBadge.tsx

import { Text } from '@mantine/core';
import type { StreamLiveStatus } from '@/lib/types/Stream';
import classes from './StreamDetail.module.css';

interface StreamLiveStatusBadgeProps {
  liveStatus: StreamLiveStatus;
}

const STATUS_CONFIG: Record<StreamLiveStatus, { dotClass: string; label: string }> = {
  live: { dotClass: classes.liveIndicatorDotLive, label: 'Live' },
  recording: { dotClass: classes.liveIndicatorDotRecording, label: 'Live (Recording)' },
  offline: { dotClass: classes.liveIndicatorDotOffline, label: 'Offline' },
  unknown: { dotClass: classes.liveIndicatorDotUnknown, label: 'Status Unavailable' },
};

export function StreamLiveStatusBadge({ liveStatus }: StreamLiveStatusBadgeProps) {
  const config = STATUS_CONFIG[liveStatus];

  return (
    <span className={classes.liveIndicator}>
      <span className={`${classes.liveIndicatorDot} ${config.dotClass}`} />
      <Text component="span" size="sm">
        {config.label}
      </Text>
    </span>
  );
}
